var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3202,
    cy: 28.4996,
    r: 28.16,
    fill: "#050505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6576 19.7113C27.6576 19.9659 27.7587 20.2101 27.9388 20.3901C28.1188 20.5702 28.363 20.6713 28.6176 20.6713H34.8672L18.8832 36.6553C18.7259 36.8389 18.6437 37.0752 18.6531 37.3168C18.6624 37.5584 18.7626 37.7876 18.9335 37.9586C19.1045 38.1295 19.3337 38.2297 19.5753 38.239C19.8169 38.2484 20.0531 38.1662 20.2368 38.0089L36.2016 22.0441V28.2457C36.2016 28.5003 36.3027 28.7445 36.4828 28.9245C36.6628 29.1046 36.907 29.2057 37.1616 29.2057C37.4162 29.2057 37.6604 29.1046 37.8404 28.9245C38.0204 28.7445 38.1216 28.5003 38.1216 28.2457V19.6057C38.1216 19.3766 38.0306 19.1568 37.8685 18.9948C37.7065 18.8327 37.4867 18.7417 37.2576 18.7417H28.6176C28.4907 18.7417 28.3651 18.7668 28.248 18.8157C28.1309 18.8645 28.0246 18.9361 27.9353 19.0263C27.8461 19.1164 27.7756 19.2234 27.7279 19.341C27.6802 19.4586 27.6563 19.5844 27.6576 19.7113Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.e8caad4e324ecbe24e16fd36fd3f9d1f.svg";
export { ForwardRef as ReactComponent };